<span class="indsearchBoxIn" *ngIf="useClass==0" >
  <div class="rela">
    <button class="btnIndSearch" title="搜索" (click)="toSearchPage()"><img src="../../../assets/images/btnIndSearchBlue.png"/></button>
    <input type="text" class="search-key inputIndSearch" placeholder="请输入企业名称"
         [(ngModel)]="keyWord" (keyup)="inputSomething($event)"
         [class.normalInput]="isFocus" (focus)="isFocus=true;showResultDiv=true;searchByKey()" (blur)="isFocus=false;showResultDiv=isMouseOnResultDiv"
         />
  </div>
  <div [hidden]="!showResultDiv" class="result-div"
       [class.normalResult]="isFocus"
       (mouseenter)="isMouseOnResultDiv=true"
       (mouseleave)="isMouseOnResultDiv=false">
    <ul class="list">
      <li *ngFor="let company of companyList"
          [class.search-li]="!company.isHighlight"
          [class.search-highlight-li]="company.isHighlight"
          [class.history]="company.isHistory"
          (mouseenter)="clearHighlight();company.isHighlight=true"
          (mouseleave)="company.isHighlight=false"
          (click)="toSearchPage(company);keyWord=company.companyName">
        <div class="compName1">{{company.companyName}}</div>
        <!--<span>{{company.companyName.length<=12?company.companyName:(company.companyName.substring(0,12)+'...')}}</span>-->
        <a *ngIf="company.isHistory" (click)="deleteQueryHistory(company.companyName,$event)">删除</a>
      </li>
      <li class="search-li delete-history" *ngIf="isShowDeleteAll"><a (click)="deleteAllHistory($event)">删除历史</a></li>
    </ul>

  </div>
</span>

<!--大屏-->
<div class="navSearchBox" *ngIf="useClass==1">
  <input type="text" class="top_txtbox search-key-screen" size="19" placeholder="请输入您要搜索的内容"
         [(ngModel)]="keyWord" (keyup)="inputSomething($event)"
         (focus)="showResultDiv=true;searchByKey()" (blur)="showResultDiv=isMouseOnResultDiv">
  <button class="navGo" (click)="toSearchPage()"></button>
  <div [hidden]="keyWord=='' || !showResultDiv" class="result-div-screen"
       (mouseenter)="isMouseOnResultDiv=true"
       (mouseleave)="isMouseOnResultDiv=false">
    <ul>
      <li *ngFor="let company of companyList"
          [class.search-li-screen]="!company.isHighlight"
          [class.search-highlight-li-screen]="company.isHighlight"
          (mouseenter)="clearHighlight();company.isHighlight=true"
          (mouseleave)="company.isHighlight=false"
          (click)="toSearchPage(company);keyWord=company.companyName">{{company.companyName}}
      </li>
    </ul>
  </div>
</div>

<!--企业注册-->
<div *ngIf="useClass==2">
  <nz-input [nzSize]="'large'" [(ngModel)]="keyWord" (keyup)="inputSomething($event)" [nzPlaceHolder]="'请输入搜索您要入驻的企业名称'"
            (nzFocus)="showResultDiv=true;searchByKey()" (nzBlur)="showResultDiv=isMouseOnResultDiv"></nz-input>
  <div [hidden]="keyWord=='' || !showResultDiv || companyList.length==0" class="result-div-reg"
       (mouseenter)="isMouseOnResultDiv=true"
       (mouseleave)="isMouseOnResultDiv=false">
    <ul>
      <li *ngFor="let company of companyList"
          [class.search-li-reg]="!company.isHighlight"
          [class.search-highlight-li-reg]="company.isHighlight"
          (mouseenter)="clearHighlight();company.isHighlight=true"
          (mouseleave)="company.isHighlight=false"
          (click)="toSearchPage(company);keyWord=company.companyName">{{company.companyName}}
      </li>
    </ul>
  </div>
</div>


<!--报告下载-->
<div *ngIf="useClass==3">
  <nz-input [nzSize]="'large'" [(ngModel)]="keyWord" (keyup)="inputSomething($event)"
            (nzFocus)="showResultDiv=true;searchByKey()" (nzBlur)="showResultDiv=isMouseOnResultDiv"></nz-input>
  <div [hidden]="keyWord=='' || !showResultDiv || companyList.length==0" class="result-div-report"
       (mouseenter)="isMouseOnResultDiv=true"
       (mouseleave)="isMouseOnResultDiv=false">
    <ul>
      <li *ngFor="let company of companyList"
          [class.search-li-reg]="!company.isHighlight"
          [class.search-highlight-li-reg]="company.isHighlight"
          (mouseenter)="clearHighlight();company.isHighlight=true"
          (mouseleave)="company.isHighlight=false"
          (click)="toSearchPage(company);keyWord=company.companyName">{{company.companyName}}
      </li>
    </ul>
  </div>
</div>

<!--添加企业监测-->
<div *ngIf="useClass==4">
  <nz-input [nzSize]="'large'" [(ngModel)]="keyWord" (keyup)="inputSomething($event)"
            [nzPlaceHolder]="'请输入企业名称'"
            (nzFocus)="showResultDiv=true;searchByKey()" (nzBlur)="showResultDiv=isMouseOnResultDiv"></nz-input>
  <div [hidden]="keyWord=='' || !showResultDiv || companyList.length==0" class="result-div-supervise"
       (mouseenter)="isMouseOnResultDiv=true"
       (mouseleave)="isMouseOnResultDiv=false">
    <ul>
      <li *ngFor="let company of companyList"
          [class.search-li-reg]="!company.isHighlight"
          [class.search-highlight-li-reg]="company.isHighlight"
          (mouseenter)="clearHighlight();company.isHighlight=true"
          (mouseleave)="company.isHighlight=false"
          (click)="toSearchPage(company);keyWord=''">{{company.companyName}}
      </li>
    </ul>
  </div>
</div>


<!--查询-->
<div *ngIf="useClass==5">
  <nz-input [nzSize]="'large'" [(ngModel)]="keyWord" (keyup)="inputSomething($event)"
            (nzFocus)="showResultDiv=true;searchByKey()" (nzBlur)="showResultDiv=isMouseOnResultDiv"
            [nzPlaceHolder]="'请输入并选择企业名称'" ></nz-input>
  <div [hidden]="keyWord=='' || !showResultDiv || companyList.length==0" class="result-div-search-company"
       (mouseenter)="isMouseOnResultDiv=true"
       (mouseleave)="isMouseOnResultDiv=false">
    <ul>
      <li *ngFor="let company of companyList"
          [class.search-li-reg]="!company.isHighlight"
          [class.search-highlight-li-reg]="company.isHighlight"
          (mouseenter)="clearHighlight();company.isHighlight=true"
          (mouseleave)="company.isHighlight=false"
          (click)="toSearchPage(company);keyWord=company.companyName">{{company.companyName}}
      </li>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/search-box/search-box.component.html